import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Dropdown, ButtonGroup } from 'react-bootstrap'

function FontFamilyDropdown(props) {
  const { fontFamily, getFontFamily } = props

  const TIMES_ROMAN = 'Times Roman'
  const COURIER = 'Courier'
  const HELVETICA = 'Helvetica'

  const [selectedFont, setSelectedFont] = useState(fontFamily)

  const handleSelectedFont = (e) => {
    if (e !== selectedFont) {
      setSelectedFont(e)
      getFontFamily(e)
    }
  }

  // The forwardRef is important!!
  // Dropdown needs access to the DOM node in order to position the Menu
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <ButtonGroup
      href=''
      ref={ref}
      onClick={(e) => {
        e.preventDefault()
        onClick(e)
      }}
    >
      {children}
      &#9650;
    </ButtonGroup>
  ))

  return (
    <Dropdown drop='up'>
      <Dropdown.Toggle as={CustomToggle} id='dropdown-custom-components'>
        {selectedFont}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item eventKey={TIMES_ROMAN} active={selectedFont === TIMES_ROMAN} onSelect={handleSelectedFont}>
          {TIMES_ROMAN}
        </Dropdown.Item>
        <Dropdown.Item eventKey={COURIER} active={selectedFont === COURIER} onSelect={handleSelectedFont}>
          {COURIER}
        </Dropdown.Item>
        <Dropdown.Item eventKey={HELVETICA} active={selectedFont === HELVETICA} onSelect={handleSelectedFont}>
          {HELVETICA}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

FontFamilyDropdown.propTypes = {
  fontFamily: PropTypes.string.isRequired,
  getFontFamily: PropTypes.func.isRequired,
}

export default FontFamilyDropdown
